// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ɵEmptyOutletComponent } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenLayoutService } from '../../../shared/services/screen-layout-service/screen-layout.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-authorized',
  templateUrl: './authorized.component.html',
  styleUrls: ['./authorized.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgTemplateOutlet,
    ɵEmptyOutletComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class AuthorizedComponent {
  protected userService = inject(UserService);
  protected layout = inject(ScreenLayoutService);

  @Input({ required: true }) menuMode = true;
}
